<template>
  <!-- The frame every signed-in page renders in: sidenav rail + content column
       (desktop navbar, mobile top bar, the page, mobile bottom nav). The
       markup and class names are the frontend's page shell, so the global
       layout rules in index.css / shell.css apply unchanged.

       Usage:
         <app-shell :refreshing="isLoading" @refresh="load">
           <template #overlays> …modals… </template>
           <header class="pg-header">…</header>
           <div class="pg-body">…</div>
         </app-shell>
  -->
  <div class="content-body app-shell">
    <div class="row">
      <sidenav class="custom-col-width-2" />
      <div :class="[isCollapsed ? 'collapsed-col' : 'custom-col-width-10', 'content']">
        <div class="body">
          <navbar :on-refresh="onRefresh" :refreshing="refreshing" />
          <mobile-topbar :on-refresh="onRefresh" :refreshing="refreshing" />

          <slot name="overlays" />

          <div class="dn-scroll">
            <slot />
          </div>

          <bottom-nav />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sidenav from '@/components/Sidenav.vue';
import navbar from '@/components/Navbar.vue';
import mobileTopbar from '@/components/Mobile_Topbar.vue';
import bottomNav from '@/components/Bottom_Nav.vue';
import { appShellState } from '@/utils/app_shell';

export default {
  name: 'AppShell',
  components: {
    sidenav,
    navbar,
    mobileTopbar,
    bottomNav,
  },
  props: {
    // Bound with `@refresh` by pages that can reload their own data; the
    // navbar and mobile top bar show a refresh button only when it is set.
    onRefresh: {
      type: Function,
      default: null,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCollapsed() {
      return this.$store.getters.isCollapsed;
    },
  },
  // Counted so the install banner (App.vue) knows a phone bottom nav is up.
  mounted() {
    appShellState.count += 1;
  },
  beforeUnmount() {
    appShellState.count -= 1;
  },
};
</script>
